import { render, staticRenderFns } from "./PreviewVideoPlayer.vue?vue&type=template&id=0a4e7073&scoped=true"
import script from "./PreviewVideoPlayer.vue?vue&type=script&lang=js"
export * from "./PreviewVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./PreviewVideoPlayer.vue?vue&type=style&index=0&id=0a4e7073&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4e7073",
  null
  
)

export default component.exports